import React from 'react'

import _modules from '../../_modules'

const Meeting = React.lazy(() => import('./views/meeting/Meeting'))
const MeetingDetail = React.lazy(() => import('./views/meeting/MeetingDetail'))

const MeetingMinute = React.lazy(() => import('./views/meetingMinute/MeetingMinute'))
const MeetingMinuteDetail = React.lazy(() => import('./views/meetingMinute/MeetingMinuteDetail'))

const _routes = []

if (_modules.meeting) {
  _routes.push(
    ...[
      {
        path: '/meeting/:id',
        name: 'Meeting Detail',
        component: MeetingDetail,
      },
      { path: '/meeting', name: 'Meeting', component: Meeting },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/meeting-minute/:id',
        name: 'Meeting Minute Detail',
        component: MeetingMinuteDetail,
      },
      { path: '/meeting-minute', name: 'Meeting Minute', component: MeetingMinute },
    ],
  )
}

export default _routes
